import React from 'react'

const ForeCastingTable = () => {
  return (
    <>
      <div className='fore_casting_table_wrapper'>
        <table className='fore_casting_table'>
            <thead className='fore_casting_table_head'>
                <tr>
                    <th>Document Type</th>
                    <th>Upload Document </th>
                    <th> Document Status  </th>
                    <th>Document Due Date   </th>
                    <th>View File </th>
                    <th>View Example File</th>
                </tr>
            </thead>
            <tbody>
            {[1,2,5,6,5,4,7,8,9,7,8,5,4,7,5,6,4,7].map((e,i)=>{
                return(
                    <>
                <tr>
                    <td>Document Type</td>
                    <td>XXX</td>
                    <td>XXX</td>
                    <td>XXX</td>
                    <td>XXX</td>
                    <td>XXX</td>
                </tr>
                    </>
                )
            })}

            </tbody>
        </table>
      </div>
    </>
  )
}

export default ForeCastingTable
